module.exports = __webpack_public_path__ + "static/media/q2.d5a8418a.png";